import { block } from '../../utils/cn';
export const b = block('date-picker');
